const DEFAULT_FILTER_VALUE_SEPARATOR = "|";

export function serializeFilterQueryParamValues(values: unknown[], separator = DEFAULT_FILTER_VALUE_SEPARATOR): string | undefined {
  if (!Array.isArray(values) || values.length === 0) {
    return undefined;
  }

  return values.map((value) => String(value)).join(separator);
}

export function deserializeFilterQueryParamValues(value: string | null, separator = DEFAULT_FILTER_VALUE_SEPARATOR): string[] {
  if (!value) {
    return [];
  }

  return value.split(separator).filter(Boolean);
}
